import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'bitDepth';

export class BitDepth extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
